import { render, staticRenderFns } from "./office.vue?vue&type=template&id=671d594d&scoped=true&"
import script from "./office.vue?vue&type=script&lang=js&"
export * from "./office.vue?vue&type=script&lang=js&"
import style0 from "./office.vue?vue&type=style&index=0&id=671d594d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671d594d",
  null
  
)

export default component.exports